// extracted by mini-css-extract-plugin
module.exports = {"content":"_1XdUTcQoGo3YjsS36r0VaQ"};